import { jwtDecode } from "jwt-decode";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const verifyEmailCode = (code) => async (dispatch) => {
  dispatch({ type: "EMAIL_VERIFY_CODE_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verifyViaEmailCode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: decodedToken.email,
        code,
      }),
    });

    if (!response.ok) {
      throw new Error("Verification failed.");
    }

    const data = await response.json();

    if (data.verifyCode === true) {
      dispatch({ type: "EMAIL_VERIFY_CODE_SUCCESS", payload: data });
    } else {
      dispatch({
        type: "EMAIL_VERIFY_CODE_ERROR",
        payload: "Verification failed. Please try again.",
      });
    }
  } catch (error) {
    dispatch({
      type: "EMAIL_VERIFY_CODE_ERROR",
      payload: error.message || "Something went wrong.",
    });
  }
};

export const resendEmailCode = () => async (dispatch) => {
  dispatch({ type: "RESEND_EMAIL_CODE_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/sendEmailVerifyCode`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: decodedToken.email }),
    });

    if (response.status === 200) {
      dispatch({ type: "RESEND_EMAIL_CODE_SUCCESS" });
    } else {
      dispatch({
        type: "RESEND_EMAIL_CODE_ERROR",
        payload: "Failed to resend the code.",
      });
    }
  } catch (error) {
    dispatch({
      type: "RESEND_EMAIL_CODE_ERROR",
      payload: "Error occurred while resending code.",
    });
  }
};

export const rememberDeviceAction = () => async (dispatch) => {
  dispatch({ type: "REMEMBER_DEVICE_LOADING" });

  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const deviceId = result.visitorId;

    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/addRememberDevice`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        rememberDeviceCheck: true,
        deviceId,
        userGuid: decodedToken.userGuid,
      }),
    });

    if (!response.ok) throw new Error("Failed to remember device");

    dispatch({ type: "REMEMBER_DEVICE_SUCCESS" });
  } catch (error) {
    dispatch({
      type: "REMEMBER_DEVICE_ERROR",
      payload: "Error remembering device.",
    });
  }
};

export const resetEmailDialogState = () => ({
  type: "RESET_EMAIL_DIALOG_STATE",
});
